import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { CFRD_FACILITIES } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/cfrd/facilities/new")({
  component: () => <DeptContentForm cfg={CFRD_FACILITIES} />,
});
